<template>
    
  <div class="container">
    <div class="padding_box">
      <div class="submit_input">
        <el-input
          type="textarea"
          v-model="questionContent"
          :autosize="{ minRows: 3 }"
          maxlength="300"
          show-word-limit
          :placeholder="$t('lang.external.fzsy.content.home.请输入问题内容')"
        />
      </div>

      <div class="top-btn">
        <span class="btn1" @click="submitQ">{{
          $t('lang.external.fzsy.content.home.提交问题')
        }}</span>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-title">
        {{ $t('lang.external.fzsy.content.home.最新问题') }}（{{ Allcount }}）
      </div>
      <div
        class="questionsBox"
        v-for="item in comments"
        :key="item.id"
        :style="
          isOverFlow && divHeight != 0
            ? { height: questionItemHeight + 'px', overflow: 'hidden' }
            : {}
        "
      >
        <div class="questionItem">
          <div class="leftD">
            <div>
              <img
                src="https://exp-api.vrbook.vip/upload/image/202110/20211013616650526826e.jpg"
                alt=""
              />
            </div>
            <div
              class="textBox"
              id="textBox"
              :style="divHeight === 0 ? {} : { height: divHeight }"
            >
              {{ item.question }}
            </div>
          </div>
          <div class="rightD">
            <img
              :src="
                item.leftSelect_icon
                  ? item.leftIcon_default
                  : item.leftIcon_select
              "
              width="25px"
              alt=""
              @click="changeIcon(item.id)"
            />
          </div>
        </div>
        <!-- 下拉项 -->
        <div class="questionBox" :class="item.isShow ? 'isShow' : 'dontShow'">
          <div class="teacherAnswer">
            <div class="dis top teacherQ">
              <span>{{ answerInfo.teaName + '：' }}</span>
            </div>
            <div class="dis question1 meQ">
              <div>
                <span>{{ answerInfo.answer }}</span>
              </div>
              <div>
                <span>{{ answerInfo.answer_time }}</span>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div
                class="pading1"
                v-for="questionChild in answerInfo.child"
                :key="questionChild.id"
              >
                <div class="dis top">
                  <span>{{ questionChild.stuName + '：' }}</span>
                </div>
                <div class="dis">
                  <div>
                    <span>{{ questionChild.question }}</span>
                  </div>
                  <div>
                    <span>{{ questionChild.created_at }}</span>
                  </div>
                  <div class="answer">
                    <div>
                      <div class="dis top">
                        <span>{{ questionChild.teaName + '：' }}</span>
                      </div>
                      <div class="dis">
                        <div>
                          <span>{{ questionChild.answer }}</span>
                        </div>
                        <div>
                          <span>{{ questionChild.answer_time }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <paginationChange :pageData="pageData" @chagePage="chagePage" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { questionInfo } from '@/api/personalCenter/index'
import { subQuestion, questionList } from '@/api/experiment/index'
import paginationChange from '../../common/paginationChange.vue'
export default {
  name: '',
  components: { paginationChange },
  data() {
    return {
      isOverFlow: true,
      divHeight: 0,
      isShow: false,
      questionItemHeight: 0,
      answerInfo: {},
      Allcount: 0,
      pageData: {
        total: 24,
        pageSize: 4,
        page: 1,
      },
      questionContent: '',
      newComment: '',
      comments: [],
      activeComment: undefined,
      image: this.publicData.serverUrl + 'images//head.webp',
      timer: null,
    }
  },
  watch: {},
  computed: {
    ...mapState(['userInfo']),
    commentNum() {
      let num = 0
      this.comments.forEach((v) => {
        num += v.reply.length
      })
      num += this.comments.length
      return num + 1
    },
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {
    this.loadListdata()
  },
  mounted() {},
  methods: {
    cancelComment() {
      this.activeComment = undefined
    },
    handleComment(id) {
      if (this.activeComment === id) {
        this.activeComment = undefined
      } else {
        this.activeComment = id
        this.newComment = ''
      }
    },
    changeIcon(q_id) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        questionInfo(q_id).then((res) => {
          const { data } = res
          this.answerInfo = data
          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].id == q_id) {
              this.comments[i].leftSelect_icon =
                !this.comments[i].leftSelect_icon
              if (this.answerInfo.answer != undefined) {
                this.comments[i].isShow = !this.comments[i].isShow
              } else {
                this.comments[i].isShow = false
              }
            } else {
              this.comments[i].leftSelect_icon = false
              this.comments[i].isShow = false
            }
          }
        })
      }, 200)
    },
    submitQ() {
      if (!window.localStorage.getItem('token')) {
        this.$notify({
          type: 'error',
          message: '请先登录!',
          duration: 1500,
          title: 'ERROR',
        })
        return
      }
      if (!this.questionContent) {
        this.$notify({
          type: 'error',
          message: '问题内容不能为空!',
          duration: 1500,
          title: '提交失败',
        })
        return
      }
      if (this.timer) clearTimeout(this.timer)
      var that = this
      this.timer = setTimeout(() => {
        subQuestion({
          course_id: window.localStorage.getItem('expId'),
          question: that.questionContent,
        }).then((res) => {
          this.$notify({
            type: 'success',
            message: '问题提交成功!',
            duration: 1500,
            title: 'SUCCESS',
          })
          that.questionContent = ''
          that.loadListdata()
        })
      }, 500)
    },
    loadListdata() {
      var that = this
      questionList({
        course_id: 1,
        problem_type: 1,
        limit: 4,
        page: that.pageData.page,
      }).then((res) => {
        const { data } = res.data
        for (let i = 0; i < data.length; i++) {
          data[i].leftSelect_icon = false
          data[i].isShow = false
          data[i].leftIcon_default = require('@/img/select_Icon_up.png')
          data[i].leftIcon_select = require('@/img/select_Icon_down.png')
        }
        this.comments = data
        this.Allcount = res.data.total
        this.pageData.page = res.current_page
        this.pageData.total = res.data.total
        this.pageData.pageSize = res.data.per_page
      })
    },
    chagePage(val) {
      this.pageData.page = val
      this.loadListdata()
    },
  },
}
</script>

<style lang="scss" scoped>
.container  {
  width: 100%;
  //   padding: 20px;
}
.padding_box {
  padding: 9px 20px 20px 20px;
}
p {
  margin: 0;
}
.name {
  color: #666666;
}
.comment {
  font-size: 16px;
  color: #999999;
}
.top {
  border-bottom: 1px solid #ccd4da;
  &-btn {
    padding: 10px 0 20px 0px;
    border-bottom: 1px solid #ccd4da;
    .btn1 {
      font-size: 16px;
      padding: 5px 18px;
      border-radius: 5px;
      background-color: #fff;
      background-image: url(../../../img/button.png);
      background-size: 100% 100%;
    }
  }
  .el-textarea {
    margin: 15px 0;
    ::v-deep .el-textarea__inner {
      border: none;
    }
  }
}
.bottom {
  padding: 0px 30px 20px 20px;

  &-title {
    color: #0c5893;
    margin-bottom: 18px;
    font-weight: bold;
  }
}
.submit_input {
  padding: 18px 0px 18px 0px;
}
//回复
.questionBox {
  padding: 20px;
  background: rgba(#5a91be, 0.1);
  margin-top: 10px;
}
.dis {
  display: inline-block;
}
.top {
  vertical-align: top;
  border-bottom: none;
}
.question1 {
  width: 100%;
}
.teacherQ {
  width: 10%;
}
.meQ {
  width: 80%;
  margin-left: 10px;
}
.pading1 {
  border-top: 1px solid #dadada;
  padding: 10px;
  padding-left: 3vw;
}

.questionsBox {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
  .questionItem {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .leftD {
      display: flex;
      align-items: center;
      img {
        width: 53px;
        height: 53px;
        border-radius: 50%;
      }
    }
    .rightD {
      cursor: pointer;
    }
  }
}
.textBox {
  line-height: 20px;
  margin-left: 20px;
}
.dontShow {
  display: none;
}
.isShow {
  display: block;
}
.teacherAnswer {
  padding-bottom: 10px;
}
</style>